import type { ChipProps, SxProps } from "@mui/material";

export const ShiftChipTypes = {
  URGENT: "URGENT",
  STILL_BOOKABLE: "STILL_BOOKABLE",
  WORKER_LEFT_EARLY: "WORKER_LEFT_EARLY",
  WORKER_LEFT_EARLY_REPLACEMENT_WORKER: "WORKER_LEFT_EARLY_REPLACEMENT_WORKER",
  AWAITING_REQUESTS: "AWAITING_REQUESTS",
  PENDING_REQUESTS: "PENDING_REQUESTS",
  INSTANT_BOOK: "INSTANT_BOOK",
} as const;

export type ShiftChipType = typeof ShiftChipTypes[keyof typeof ShiftChipTypes];

export interface ShiftChipAdditionalData {
  priorityTill?: string;
  extendedBookabilityTo?: Date;
  facilityTimeZone?: string;
  pendingRequestCount?: number;
}

export interface ShiftChip {
  type: ShiftChipType;
  additionalData?: ShiftChipAdditionalData;
  handleClick?: () => void;
  label?: string;
}

export interface ShiftChipData {
  type: ShiftChipType;
  label: string;
  color: ChipProps["color"];
  getTooltip: (additionalData?: ShiftChipAdditionalData) => string;
  additionalData?: ShiftChipAdditionalData;
  handleClick?: () => void;
  customStyles?: SxProps;
}
